export enum EnumRelatorioLotacoes {
  Defensores_Comarca = 1,
  Defensores_Lotacao = 2,
  Defensores_Nucleo = 3,
  Estagiarios_Defensoria = 4,
  Estagiarios_Setor = 5,
  Estagiarios_Nucleo = 6
}
